// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetChangeRequestApprovalOnDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ChangeRequestApprovalDTO from '../models/ChangeRequestApprovalDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    changeRequestId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            changeRequestId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    changeRequestId: 'changeRequestId',
}

interface Result extends ResultDTO {
    changeRequestApproval: ChangeRequestApprovalDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            changeRequestApproval: null,
        },
        initValues);
    },
    changeRequestApproval: 'changeRequestApproval',
}

export { Request, Result };